import { Loader } from "@launchmetrics/lm-ui";
import K2Api from "lib/ajax/K2Api";
import PropTypes from 'prop-types';
import { useState } from "react";
import Button from "react-bootstrap/Button";
import { Lock, Unlock } from 'react-feather';
import TooltipWrapper from "components/LM/common/TooltipWrapper";

const K2_API = new K2Api();

function VoiceLockButton(props) {
	const { disabled, voice_id } = props;
	const { onTake, onRelease } = props;

	const [lock, setLock] = useState(props.lock);
	const [processing, setProcessing] = useState(false);

	const showLoader = () => {
		if (processing) {
			return <Loader styleProps={{ marginLeft: '10px'}}size={20} />;
		}
	}

	const onClickTake = () => {
		setProcessing(true);
		K2_API.put(`/voices/${voice_id}/lock`)
			.then(() => {
				setLock({ owner: true, releasable: true });
				onTake();
			}).catch(error => {
				console.error(error);
			}).finally(() => setProcessing(false));
	};

	const onClickRelease = () => {
		setProcessing(true);
		K2_API.delete(`/voices/${voice_id}/lock`)
			.then(() => {
				setLock(null);
				onRelease();
			}).catch(error => {
				console.error(error);
			}).finally(() => setProcessing(false));
	};

	let icon, title, text, onClick;
	let disableButton = false;
	const sizes = { width: 14, height: 14 };
	if (lock && (lock.owner || lock.releasable)) {
		icon = <Lock {...sizes} className="text-danger"/>;
		title = 'Unlock Profile';
		text = '';
		if (lock.releasable && !lock.owner) {
			text = lock.user;
		}
		onClick = onClickRelease;
	} else if (lock) {
		icon = <Unlock {...sizes} />
		title = `Cannot release`;
		text = lock.user;
		disableButton = true;
	} else {
		icon = <Unlock {...sizes}/>
		title = 'Lock Profile';
		text = '';
		onClick = onClickTake;
	}

	return <TooltipWrapper placement="top" tooltip={title}>
		<Button disabled={disabled || disableButton || processing} className="btn-sm ml-2 custom-gray-border" variant="outline-dark" onClick={() => onClick()}>
			{icon} {text} {showLoader()}
		</Button>
	</TooltipWrapper>
}

VoiceLockButton.propTypes = {
	voice_id: PropTypes.string.isRequired,
	lock: PropTypes.shape({
		owner: PropTypes.bool.isRequired,
		releasable: PropTypes.bool.isRequired,
		user: PropTypes.string
	}),
	onTake: PropTypes.func.isRequired,
	onRelease: PropTypes.func.isRequired,
	disabled: PropTypes.bool
};

export default VoiceLockButton;
